import { render, staticRenderFns } from "./RemindingDailywork.vue?vue&type=template&id=fc3cd9b2&"
import script from "./RemindingDailywork.vue?vue&type=script&lang=js&"
export * from "./RemindingDailywork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports